exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#header.unstuck{margin-bottom:-65px}.header{background-color:#353d42;height:65px;position:fixed;width:100%;top:0;left:0;z-index:100;display:flex;align-items:center;justify-content:center}.header.bump{top:111px}@media (min-width:428px){.header.bump{top:91px}}@media (min-width:576px){.header.bump{top:75px}}@media (min-width:768px){.header.bump{top:55px}}@media (min-width:1200px){.header.bump{top:35px}}.header.unstuck{position:static}.header-logo{max-width:100%;width:556px;padding:0 33px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-85874ce0","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 377
// module chunks = 0